import Head from 'next/head'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import styled from 'styled-components'

import { t } from 'localization'
import { NextPage } from 'next'
import { PagesQA } from 'shared/dataAttributes'
import { colors, media, styles } from 'shared/lib'
import { AdminPageResponse } from 'shared/utils/getAPServerSideProps'

type AdminPageProps = AdminPageResponse

export const PagesAdmin: NextPage<AdminPageProps> = ({ content, slug, title }) => {
  return (
    <>
      <Head>
        {/* i18next-extract-disable-next-line */}
        <title>{t(`pages.${slug}.pageTitle`, `${title} | Flight Club`)}</title>
      </Head>
      <Wrapper data-qa={PagesQA.DynamicSlug}>
        <ReactMarkdown rehypePlugins={[rehypeSlug]}>{content}</ReactMarkdown>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  background-color: ${colors.FC2_WHITE};
  height: 100%;
  min-height: inherit;
  padding: ${styles.mobilePageLayoutPadding};
  ${media.large`
    padding: 80px 150px 100px;
  `}
`
